import { useEffect, useState, useRef } from 'react'
import { useStores } from '@/store'

export function useQueryParams(queryParams, delay = 200) {
  const [debouncedParams, setDebouncedParams] = useState(queryParams)
  const timer = useRef(null)

  useEffect(() => {
    if (timer.current) clearTimeout(timer.current)
    timer.current = setTimeout(() => {
      setDebouncedParams(queryParams)
    }, delay)
    return () => clearTimeout(timer.current)
  }, [queryParams, delay])

  return debouncedParams
}

export function usePaginatedFetch(queryParams) {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const { restaurantStore } = useStores()
  const debouncedParams = useQueryParams(queryParams, 200)
  const ref = useRef()

  useEffect(() => {
    console.log('usePaginatedFetch', debouncedParams.id)
    if (!debouncedParams?.id) return
    let canceled = false
    let page = 1

    async function fetchAll() {
      setLoading(true)

      if(ref.current !== debouncedParams.id) {
        setData([])
      }
      ref.current = debouncedParams.id
      while (true) {
        const { data: pageData = [], headers } = await restaurantStore.getGuideItems(debouncedParams?.id, {
          ...debouncedParams,
          page,
          id: null
        })

        if (canceled) return
        if(page === 1) {
          setData(pageData)
        } else {
          setData(prev => [...prev, ...pageData])
        }

        const totalPages = parseInt(headers?.total_pages || '1')
        if (page >= totalPages) break

        page++
      }

      if (!canceled) {
        setLoading(false)
      }
    }

    fetchAll()

    return () => {
      canceled = true
    }
  }, [debouncedParams])

  return { data, loading }
}
